import { OrderAdDetail } from "@core/models/order-ad-detail.model";

export class OrderMaterialViewModel {
	readonly fullMaterialId: string;
	readonly materialId: string;
	readonly sizeColumnData: string;
	
	readonly orderLine: OrderAdDetail;

	isDone: boolean;

	statusText: string | undefined;
	previewUrl: string | undefined;
	updatedPreviewUrl: string | undefined;

	constructor (orderLine: OrderAdDetail, fullMaterialId: string, sizeColumnData: string, statusText: string) {
		this.orderLine = orderLine;

		this.fullMaterialId = fullMaterialId;

		this.materialId = orderLine.materialId;
		this.sizeColumnData = sizeColumnData;

		this.isDone = Boolean(orderLine && orderLine.materialStatus && orderLine.materialStatus.done);
		this.statusText = statusText;
	}
}
